import type { Shipping } from 'src/types';

type ShippingSort = (s1: Shipping, s2: Shipping) => number;

export const getSortedShipping = (
  shippings: Shipping[],
  isSortByFastest: boolean
): Shipping | undefined => {
  if (shippings.length === 0) {
    return undefined;
  }
  const sortedShippings = sortShippings(
    shippings,
    isSortByFastest ? sortByFastest : sortByCheapest,
    isSortByFastest ? sortByCheapest : sortByFastest
  );
  return sortedShippings[0];
};

const sortByCheapest: ShippingSort = (s1: Shipping, s2: Shipping) => {
  if (s1.shippingCost === undefined && s2.shippingCost !== undefined) return 1;
  if (s1.shippingCost !== undefined && s2.shippingCost === undefined) return -1;
  if (s1.shippingCost === undefined && s2.shippingCost === undefined) return 0;
  return s1.shippingCost! - s2.shippingCost!;
};

const sortByFastest: ShippingSort = (s1: Shipping, s2: Shipping) => {
  if (s1.deliveryDays === null && s2.deliveryDays !== null) return 1;
  if (s1.deliveryDays !== null && s2.deliveryDays === null) return -1;
  if (s1.deliveryDays === null && s2.deliveryDays === null) return 0;
  if (s1.deliveryDays!.min !== s2.deliveryDays!.min) {
    return s1.deliveryDays!.min - s2.deliveryDays!.min;
  }
  return s1.deliveryDays!.max - s2.deliveryDays!.max;
};

const sortShippings = (
  shippings: Shipping[],
  primarySort: ShippingSort,
  secondarySort: ShippingSort
): Shipping[] => {
  if (shippings.length === 0) {
    return shippings;
  }
  return [...shippings].sort((s1: Shipping, s2: Shipping) => {
    const primarySortResult = primarySort(s1, s2);
    if (primarySortResult !== 0) {
      return primarySortResult;
    }
    return secondarySort(s1, s2);
  });
};
